<div class="body">
    <div class="col-12 pt-4" *ngIf="formulaire">
        <form [formGroup]="formulaire">
            <h4 class="ml-2 pt-3">B - Les premiers contacts</h4>
            <h5 class="mt-4 ml-2">B.1 - L'origine du premier contact (victime ou non)</h5>
            <div class="card-header text-muted">
                <i>Indiquer le nombre de personnes en contact avec l'association pour la première fois au cours de
                    l'année,
                    <u>qu'elles soient ou non victimes</u>, selon l'origine du premier contact
                </i>
            </div>
            <fieldset class="ml-2 mr-2 pt-2">
                <div class="card rounded bg-light shadow" style="border-width:2px">
                    <div class="form-row">
                        <div class="col-md-12">
                            <table id="table-B1" class="table table-sm m-0 table-bordered">
                                <thead class="thead-light">
                                    <tr>
                                        <th class="text-center align-middle">Origine du contact</th>
                                        <th class="text-center align-middle">Nombre de personnes</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 70%">Démarche pro-active
                                            de l'association vers la personne</td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="99999"
                                                label="bbPremContactOrigAsso" classeSupplementaire="text-right"
                                                libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 70%">A l'initiative de la
                                            personne</td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="99999"
                                                label="bbPremContactOrigPerso" classeSupplementaire="text-right"
                                                libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-right align-middle pl-2" style="width: 70%">
                                            <b> TOTAL</b>
                                            <span *ngIf="modeRendu.enModeSaisie$ | async">
                                                <button class="btn-info ml-1 mr-2"
                                                    title="Calcul automatique du total à partir des données ventilées"
                                                    (click)="calculTotalTableauB1()">
                                                    <b><i>Calcul automatique</i></b>
                                                </button>
                                            </span>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="999999"
                                                label="bbPremContactOrigTot"
                                                classeSupplementaire="integer-input-total text-right" libelle="vide"
                                                [erreursCroisees]="['ctrlB1', 'ctrlB4']">
                                            </bis-integer-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlB1">
                                            </bis-affiche-erreurs-croisees>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlB4">
                                            </bis-affiche-erreurs-croisees>
                                            <bis-affiche-alertes labelAlerte='alertB1'></bis-affiche-alertes>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </fieldset>

            <h5 class="mt-5 ml-2">B.2 - Le mode de premier contact (victime ou non)</h5>
            <div class="card-header text-muted">
                <i>Indiquer le nombre de personnes en contact avec l'association pour la première fois au cours de
                    l'année,
                    <u>qu'elles soient ou non victimes</u>, selon le mode de premier contact
                </i>
            </div>
            <fieldset class="ml-2 mr-2 pt-2">
                <div class="card rounded bg-light shadow" style="border-width:2px">
                    <div class="form-row">
                        <div class="col-md-12">
                            <table id="table-B2" class="table table-sm m-0 table-bordered">
                                <thead class="thead-light">
                                    <tr>
                                        <th class="text-center align-middle">Mode de contact</th>
                                        <th class="text-center align-middle">Nombre de personnes</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 70%">Courrier, courriel,
                                            fax</td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="99999"
                                                label="bbPremContactModeEcrit" classeSupplementaire="text-right"
                                                libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 70%">Appel téléphonique
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="99999"
                                                label="bbPremContactModeTel" classeSupplementaire="text-right"
                                                libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 70%">Présentation à la
                                            permanence</td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="99999"
                                                label="bbPremContactModePres" classeSupplementaire="text-right"
                                                libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-right align-middle pl-2" style="width: 70%">
                                            <b> TOTAL</b>
                                            <span *ngIf="modeRendu.enModeSaisie$ | async">
                                                <button class="btn-info ml-1 mr-2"
                                                    title="Calcul automatique du total à partir des données ventilées"
                                                    (click)="calculTotalTableauB2()">
                                                    <b><i>Calcul automatique</i></b>
                                                </button>
                                            </span>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="999999"
                                                label="bbPremContactModeTot"
                                                classeSupplementaire="integer-input-total text-right" libelle="vide"
                                                [erreursCroisees]="['ctrlB2', 'ctrlB5']">
                                            </bis-integer-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlB2">
                                            </bis-affiche-erreurs-croisees>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlB5">
                                            </bis-affiche-erreurs-croisees>
                                            <bis-affiche-alertes labelAlerte='alertB2'></bis-affiche-alertes>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </fieldset>

            <div style="page-break-before: always"></div>

            <h5 class="mt-5 ml-2">B.3 - L'origine de l'orientation de la VICTIME vers l'association (victime uniquement)
            </h5>
            <div class="card-header text-muted">
                <i>Indiquer le nombre de victimes d'infractions pénales reçues par l'association pour la première fois
                    dans l'année,
                    selon l'origine de l'orientation vers l'association<br>
                    <u>Compter une seule réponse par victime</u>
                </i>
            </div>
            <fieldset class="ml-2 mr-2 pt-2 pb-3">
                <div class="card rounded bg-light shadow" style="border-width:2px">
                    <div class="form-row">
                        <div class="col-md-12">
                            <table id="table-B3" class="table table-sm m-0 table-bordered">
                                <thead class="thead-light">
                                    <tr>
                                        <th class="text-center align-middle">Type d'origine de l'orientation</th>
                                        <th class="text-center align-middle">Nombre de victimes reçues</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 70%">Réquisitions du
                                            Procureur de la République (tous types de réquisition)</td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="99999"
                                                label="bbPremContactOrientProc" classeSupplementaire="text-right"
                                                libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 70%">Autres services
                                            judiciaires (JAP, JE, autres magistrats, SAUJ...)</td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="99999"
                                                label="bbPremContactOrientAutjud" classeSupplementaire="text-right"
                                                libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 70%">Service pénitentiaire
                                            (SPIP, établissements pénitentiaires...)</td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="99999"
                                                label="bbPremContactOrientPenit" classeSupplementaire="text-right"
                                                libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 70%">Police, gendarmerie
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="99999"
                                                label="bbPremContactOrientPolgend" classeSupplementaire="text-right"
                                                libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 70%">UMJ (Unité Médico
                                            Judiciaire)</td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="99999"
                                                label="bbPremContactOrientUmj" classeSupplementaire="text-right"
                                                libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 70%">Structure
                                            hospitalière, corps médical</td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="99999"
                                                label="bbPremContactOrientHosto" classeSupplementaire="text-right"
                                                libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 70%">Mairie, collectivités
                                            territoriales, service social</td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="99999"
                                                label="bbPremContactOrientColter" classeSupplementaire="text-right"
                                                libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 70%">Autre association
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="99999"
                                                label="bbPremContactOrientAsso" classeSupplementaire="text-right"
                                                libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 70%">Ministère de la
                                            Justice (service de l'accès au droit et à la justice et de l'aide aux
                                            victimes)</td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="99999"
                                                label="bbPremContactOrientSad" classeSupplementaire="text-right"
                                                libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 70%">116 006 - Plate-forme
                                            téléphonique à l'attention des victimes</td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="99999"
                                                label="bbPremContactOrientPftel" classeSupplementaire="text-right"
                                                libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 70%">France Victimes
                                            (conventions nationales)</td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="99999"
                                                label="bbPremContactOrientFrvict" classeSupplementaire="text-right"
                                                libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 70%">Partenaires en
                                            conventions locales avec l'association</td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="99999"
                                                label="bbPremContactOrientPart" classeSupplementaire="text-right"
                                                libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 70%">Publicité, médias,
                                            internet, plaquettes d'information</td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="99999"
                                                label="bbPremContactOrientPub" classeSupplementaire="text-right"
                                                libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 70%">Relation personnelle
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="99999"
                                                label="bbPremContactOrientRela" classeSupplementaire="text-right"
                                                libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 70%">Autres
                                            origines<br><br>
                                            <bis-string-input [rootForm]="formulaire" label="bbPremContactOrientAutrDet"
                                                longueurMax=150>
                                            </bis-string-input>
                                            <bis-affiche-alertes labelAlerte='alertB4'></bis-affiche-alertes>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="99999"
                                                label="bbPremContactOrientAutr" classeSupplementaire="text-right"
                                                libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-right align-middle pl-2" style="width: 70%">
                                            <b> TOTAL</b>
                                            <span *ngIf="modeRendu.enModeSaisie$ | async">
                                                <button class="btn-info ml-1 mr-2"
                                                    title="Calcul automatique du total à partir des données ventilées"
                                                    (click)="calculTotalTableauB3()">
                                                    <b><i>Calcul automatique</i></b>
                                                </button>
                                            </span>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" [max]="999999"
                                                label="bbPremContactOrientTot"
                                                classeSupplementaire="integer-input-total text-right" libelle="vide"
                                                [erreursCroisees]="['ctrlB3', 'ctrlB6']">
                                            </bis-integer-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlB3">
                                            </bis-affiche-erreurs-croisees>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlB6">
                                            </bis-affiche-erreurs-croisees>
                                            <bis-affiche-alertes labelAlerte='alertB3'></bis-affiche-alertes>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </fieldset>
        </form>
    </div>
</div>